import { render, staticRenderFns } from "./AvailabilityRegionList.vue?vue&type=template&id=58522780&"
import script from "./AvailabilityRegionList.vue?vue&type=script&lang=js&"
export * from "./AvailabilityRegionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports